import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { AppProvider } from '@shopify/polaris';
import enTranslations from '@shopify/polaris/locales/en.json';

import { OpsLink } from './components/OpsLink';
import { App } from './App';

import '@shopify/polaris/build/esm/styles.css';

const root = document.getElementById('root');
if (!root) throw new Error('no #root');

createRoot(root).render(
  <StrictMode>
    {/* English only, deliberately: one user, who is the person reading this. */}
    {/* ⚠ `linkComponent` is load-bearing — see OpsLink. Without it every nav
        click also performs a real navigation, the SPA reboots, and the route
        resets to 'dashboard'. */}
    <AppProvider i18n={enTranslations} linkComponent={OpsLink}>
      <App />
    </AppProvider>
  </StrictMode>
);
